<ngb-alert
  class="banner"
  [type]="notificationBanner.type"
  (closed)="onClose()"
  [dismissible]="true"
>
  <div class="container-fluid">
    @if (notificationBanner.title) {
      <div class="row">
        <div class="col">
          <label class="banner-title">{{ notificationBanner.title }}</label>
        </div>
      </div>
    }
    <div class="row">
      <div class="col">
        <label>{{ notificationBanner.bodyText }}</label>
      </div>
    </div>
  </div>
</ngb-alert>
